import type { App, DirectiveBinding } from 'vue'

/**
 * 滚动容器指令
 * 此指令已不再主要使用，因为我们已经实现了全局滚动处理
 * 保留此指令仅作为备用
 */
export const scrollContainer = {
  mounted(el: HTMLElement) {
    // 已不再需要单独监听每个容器
    // 全局处理已在scrollHelper.ts中实现
  }
}

// 注册全局指令
export const setupScrollDirectives = (app: App) => {
  app.directive('scroll-container', scrollContainer)
} 